import { Box, Paper, Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { CheckBoxItem } from "../../app/models/common/checkBoxItem";
import { useEffect, useState } from "react";
import AppDeclarationCheckbox from "./common/AppDeclarationCheckbox";
import MembershipFormModel from "../../app/models/membership/membershipFormModel";

export default function Declaration() {
    const methods = useFormContext();
    const { control, reset } = methods;

    const {
        formField: {
            Declaration
        }
    } = MembershipFormModel;

    const [declarationOption,] = useState<CheckBoxItem>({
        id: Declaration.name,
        value: ''
    });

    useEffect(() => {
        reset({
            [Declaration.name]: []
        })
    }, []);

    return <>
        <Box sx={{ minWidth: "100%" }} component={Paper}>
            <Grid container rowSpacing={4} sx={{ margin: "2%" }}>

                <Grid size={{ xs: 12 }}></Grid>

                <Grid size={{ xs: 12 }}>
                    <AppDeclarationCheckbox
                        control={control}
                        name={Declaration.name}
                        option={declarationOption} />
                </Grid>

                <Grid size={{ xs: 12 }}></Grid>

            </Grid>
        </Box>
    </>
}